<div *ngIf="isAdmin==false">
  <div class="d-flex mt-1">
    <h3 class="align-self-center">Whatsapp activity</h3>
    <span class="ml-5 mt-1">
      <mat-slide-toggle [formControl]="viewConversationStatistics" class="mr-2">View statistics prior to July 2025</mat-slide-toggle>
      <svg xmlns="http://www.w3.org/2000/svg" width="16" matSuffix mat-icon-button height="16" fill="currentColor" class="bi bi-info-circle font-bold text-accent " viewBox="0 0 16 16" matTooltip="Since July 2025, pricing is based on messages instead of conversations">
        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
        <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z" />
      </svg>
    </span>
  </div>
</div>

<div *ngIf="viewConversationStatistics.value == true">
  <mat-tab-group (selectedTabChange)="onTabChange($event)" mat-stretch-tabs>
    <mat-tab label="General">
      <ng-container *ngIf="isAdmin; else user">
        <ng-content></ng-content>
      </ng-container>
      <ng-template #user>
        <app-general-activity></app-general-activity>
      </ng-template>
    </mat-tab>

    <mat-tab label="Detailed">
      <app-detailed-activity [requestCustomerCode]="customerCode"
                             [isAdmin]="isAdmin"
                             [viewConversationStatistics]="viewConversationStatistics.value"
                             (openDialog)="openSideDialog($event)">
      </app-detailed-activity>
    </mat-tab>
  </mat-tab-group>

</div>

<div *ngIf="viewConversationStatistics.value != true">
  <app-detailed-activity [requestCustomerCode]="customerCode"
                         [isAdmin]="isAdmin"
                         [viewConversationStatistics]="viewConversationStatistics.value"
                         (openDialog)="openSideDialog($event)">
  </app-detailed-activity>
</div>

<mat-drawer-container class="sidenav-container" autosize>
  <mat-drawer class="p-4 drawer-container" #drawer mode="side" position="end">
    <a class="mb-2 link-not-href" (click)="closeSideDialog()"><i class="lni-arrow-left small mt-1"></i>&nbsp;&nbsp;Back</a>
    <div class="d-flex justify-content-between align-items-center">
      <ng-container *ngIf="data.templateName != null; else type">
        <div><b>Template name</b>: {{data.templateName}}</div>
      </ng-container>

      <ng-template #type>
        <div><b>Message type</b>: {{data.messageType}}</div>
      </ng-template>
    </div>
    <div><b>RequestId</b>: {{data.id}}</div>

    <div class="d-flex mt-4 justify-content-center align-items-center">
      <app-phone-viewer *ngIf="isDeviceVisible" [currentOption]="data.template"></app-phone-viewer>
    </div>
  </mat-drawer>
</mat-drawer-container>

